var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.03406,
    y: 2.50269,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.99841,
    y: 9.49713,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.98059,
    y: 16.4971,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0341,
    y: 2.51385,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0341,
    y: 9.51385,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.98059,
    y: 16.4971,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1054,
    y: 2.53619,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9806,
    y: 9.49713,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9717,
    y: 16.4971,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#1D1D1D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap);
export default __webpack_public_path__ + "static/media/heat_map.35871dc0ee1d8c4166d9015e740cbf9d.svg";
export { ForwardRef as ReactComponent };